export const VENEZUELA_STATES = [
  "Amazonas", "Anzoátegui", "Apure", "Aragua", "Barinas", "Bolívar", "Carabobo",
  "Cojedes", "Delta Amacuro", "Distrito Capital", "Falcón", "Guárico", "La Guaira",
  "Lara", "Mérida", "Miranda", "Monagas", "Nueva Esparta", "Portuguesa", "Sucre",
  "Táchira", "Trujillo", "Yaracuy", "Zulia",
];

export const SEX_OPTIONS = [
  { value: "male", label: "Masculino" },
  { value: "female", label: "Femenino" },
  { value: "other", label: "Otro" },
  { value: "unspecified", label: "No especificado" },
];

export const CONTACT_METHODS = [
  { value: "phone", label: "Teléfono" },
  { value: "email", label: "Correo electrónico" },
  { value: "whatsapp", label: "WhatsApp" },
];

export const PLACE_TYPES = [
  { value: "street", label: "Calle" },
  { value: "hospital", label: "Hospital reportado" },
  { value: "shelter", label: "Refugio reportado" },
  { value: "church", label: "Iglesia" },
  { value: "school", label: "Escuela" },
  { value: "community", label: "Punto comunitario" },
  { value: "other", label: "Otro" },
];

export const REPORT_REASONS = [
  { value: "family", label: "Soy familiar" },
  { value: "friend", label: "Soy amigo/conocido" },
  { value: "found_saw", label: "La encontré o la vi" },
  { value: "helping", label: "Estoy ayudando a otra persona" },
  { value: "volunteer", label: "Soy voluntario" },
  { value: "aid_point", label: "Trabajo en un punto de ayuda/refugio/comunidad" },
  { value: "hospital", label: "Trabajo en un hospital/centro asistencial" },
  { value: "other", label: "Otro" },
];

export const ABUSE_REASONS = [
  { value: "false_info", label: "Información falsa" },
  { value: "already_found", label: "Persona ya encontrada" },
  { value: "inappropriate_photo", label: "Foto inapropiada" },
  { value: "duplicate", label: "Caso duplicado" },
  { value: "sensitive_exposed", label: "Datos sensibles expuestos" },
  { value: "i_am_person", label: "Soy la persona registrada" },
  { value: "correct_info", label: "Quiero solicitar corrección de información" },
  { value: "request_removal", label: "Quiero solicitar retiro" },
  { value: "malicious", label: "Uso malicioso" },
  { value: "other", label: "Otro" },
];
